import { render, staticRenderFns } from "./AdsView.vue?vue&type=template&id=49e28cd6&scoped=true"
import script from "./AdsView.vue?vue&type=script&lang=js"
export * from "./AdsView.vue?vue&type=script&lang=js"
import style0 from "./AdsView.vue?vue&type=style&index=0&id=49e28cd6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e28cd6",
  null
  
)

export default component.exports